import React from "react";
import ProjectMonarchContent from "../function-components/ProjectMonarchContent";

function ProjectMonarch() {
  return (
    <>
      <ProjectMonarchContent />
    </>
  );
}

export default ProjectMonarch;
